module.exports = "<happy-input-template [controlName]=\"formControlName\" [form]=\"form\" [required]=\"required\">\n    <ng-content select=[input-label] input-label></ng-content>\n    <ng-content select=[input-guidance] input-guidance></ng-content>\n    <textarea ngDefaultControl input-control rows=\"3\"\n              [placeholder]=\"placeholder || ''\"\n              class=\"form-control\"></textarea>\n</happy-input-template>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/happy/happy-textarea-input/happy-textarea-input.component.html
// module id = 966
// module chunks = 0